import React, {FC, Fragment} from 'react';
import {label} from "../../service";
import {CheckBox} from "../common/checkbox";
import {TourItemInsurance} from "../../types/tourItem";

interface OptionalProps {
    onChange: (id: number) => void
    optional: TourItemInsurance[],
    values: number[],
    checkoutPrice: string
    duration: number
}

export const CheckoutOptional: FC<OptionalProps> = ({onChange,optional,values, checkoutPrice,duration}) => {

    const getInsurancePrice = (item: any) => {
        let formatString = `${label('Free')}`;
        if (+(item.price) > 0) {
            formatString = `€${Math.round(item.price * 100) / 100}`;
        }
        return formatString;
    }

    return (
        <Fragment>
            {
                optional.map((item) => {
                    return (
                        <CheckBox key={item.id}
                                  onChange={() => {
                                      onChange(item.id)
                                  }}
                                  label={item.name}
                                  name={item.name}
                                  price={getInsurancePrice(item)}
                                  checked = {values[item.id]!==undefined}
                                  tooltip={item.info}
                        />
                    )
                })
            }
        </Fragment>
    )
}